// Chest and length in cm per size, from Shahmeer Sports (brief Q5). Empty until the measurements arrive.
const SIZES: { size: string; chest: number; length: number }[] = [];

export function SizeGuide() {
  return (
    <section aria-labelledby="size-guide-heading" className="space-y-3">
      <h2 id="size-guide-heading" className="text-h5">
        Size guide
      </h2>
      {SIZES.length ? (
        <table className="w-full font-sans text-body-sm">
          <caption className="sr-only">
            Jersey measurements in centimetres
          </caption>
          <thead>
            <tr className="border-b border-border text-left">
              <th scope="col" className="py-2">
                Size
              </th>
              <th scope="col" className="py-2">
                Chest (cm)
              </th>
              <th scope="col" className="py-2">
                Length (cm)
              </th>
            </tr>
          </thead>
          <tbody>
            {SIZES.map((s) => (
              <tr key={s.size} className="border-b border-border">
                <th scope="row" className="py-2 text-left font-medium">
                  {s.size}
                </th>
                <td className="py-2">{s.chest}</td>
                <td className="py-2">{s.length}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="text-body-sm text-muted-foreground">
          The size guide is coming soon. You choose your size at checkout.
        </p>
      )}
    </section>
  );
}
